import react, { useEffect, useRef } from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AdminRouter from "./AdminRouters";

const FromParamListener = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const prevPathRef = useRef<string | null>(null);
  const updatingRef = useRef(false);

  useEffect(() => {
    if (updatingRef.current) {
      updatingRef.current = false;
      prevPathRef.current = location.pathname;
      return;
    }

    const prevPathname = prevPathRef.current;
    const currPathname = location.pathname;
    const searchParams = new URLSearchParams(location.search);

    if (prevPathname && !searchParams.has("from")) {
      searchParams.set("from", prevPathname);
      const qs = searchParams.toString();
      updatingRef.current = true;
      navigate(`${currPathname}?${qs}${location.hash || ""}`, {
        replace: true,
      });
    }

    prevPathRef.current = currPathname;
  }, [location.pathname, location.search, location.hash, navigate]);

  return null;
};

const Router = () => {
  return (
    <BrowserRouter>
      <FromParamListener />
      <Routes>
        <Route path="/*" element={<AdminRouter />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
